(function() {
    'use strict';
    angular
    .module('emarket.main.post')
    .factory('PremiumPost', ['$log', 'PATH', '$http', function($log, PATH, $http) {
        var premium = {};
        premium.getFrontPage = function() {
            var promise = $http
                .get(PATH.api + '/premiums')
                .then(function(res) {
                    var premiums = res.data;
                    var response = {};
                    response.latest = premiums.post.latest;
                    response.front = premiums.post.front;
                    response.store = premiums.store;
                    
                    var totalPremium = 8 - response.front.length;
                    for (var i = 0; i < totalPremium; i += 1) {
                        response.front.push({
                            post: {
                                title: 'Espacio disponible para tu producto',
                                prices: {
                                    list: null
                                },
                                images: [
                                    {
                                        path: 'assets/available-premium.jpg'
                                    }
                                ],
                                _id: '1000' + i
                            }
                        });
                    }
                    return response;
                });
            return promise;
        };
        premium.getFromCategory = function (categoryId) {
            return $http
                .get(PATH.api + '/premiums', {
                    params: {
                        category: categoryId
                    }
                })
                .then(function (res) {
                    return res.data;
                });
        };
        return premium;
    }]);
}());
